export default __webpack_public_path__ + "static/media/Nomination-and-Remuneration-Policy.51df3337.pdf";